export default {
  props: {
    // Component name
    componentName: {
      default: 'CourseIntroduce-2',
      type: String,
    },
    // Component type
    componentType: {
      default: 0,
      type: Number,
    },
    // Component title
    componentTitle: {
      default: '',
      type: String,
    },
    columnData: {
      default: () => ({}),
      type: Object,
    },
    btn: {
      default: () => {},
      type: Object,
    },
    comparisons: {
      default: () => [],
      type: Array,
    },
    competitors: {
      default: () => [],
      type: Array,
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
  },
  methods: {
    GAReport() {
      window?.dataLayer?.push({
        event: 'LP_compare_button_click',
        user_id: this.$store.state.ucenter?.user?.uid || 'non-login',
        button_name: this.btn?.buttonText || '',
      })
    }
  }
}
